/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAidpSquare = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.278 14.227h-1.29l-.215-.733h-1.32l-.209.733H5L6.563 10h1.14zM6.71 12.599h.803l-.408-1.389zm4.121 1.628H9.668V10h1.163zM13.065 10c.465 0 .853.08 1.163.238.313.16.548.396.703.71.159.313.239.703.239 1.168 0 .465-.08.854-.24 1.168a1.534 1.534 0 0 1-.702.71c-.31.155-.698.232-1.163.233h-1.523V10zm-.383 3.343h.354a.938.938 0 0 0 .524-.134.778.778 0 0 0 .307-.407c.07-.182.105-.41.105-.686 0-.279-.035-.51-.105-.691a.777.777 0 0 0-.307-.407.937.937 0 0 0-.524-.134h-.354zM17.324 10c.531 0 .937.126 1.216.378.283.252.424.62.424 1.104 0 .322-.064.593-.191.814a1.18 1.18 0 0 1-.553.5c-.24.112-.54.169-.896.169h-.459v1.262h-1.14V10zm-.459 2.087h.233c.263 0 .452-.047.564-.14.116-.093.174-.248.174-.465 0-.216-.058-.371-.174-.464-.112-.093-.3-.14-.564-.14h-.233z" />
        <path d="M22 22H2V2h20zM4 20h16V4H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgAidpSquare as AidpSquare };
